/* Move the mid-article signup about 40% of the way into the post */
(function () {
    const cta = document.querySelector('[data-sc-inline]');
    const content = document.querySelector('.gh-article .gh-content');
    if (!cta || !content) return;

    // Only place it between top-level paragraphs, never inside a list, quote or card
    const blocks = Array.from(content.children).filter(function (el) {
        return el.tagName === 'P';
    });
    if (blocks.length < 6) return;

    const target = blocks[Math.floor(blocks.length * 0.4)];
    target.parentNode.insertBefore(cta, target);
    cta.hidden = false;
})();

/* Dismissible signup panel on posts, shown once the reader is 60% through */
(function () {
    const panel = document.querySelector('[data-sc-slide-in]');
    const content = document.querySelector('.gh-article .gh-content');
    if (!panel || !content) return;

    const KEY = 'sc-slide-in-dismissed';
    const DAYS = 14;

    try {
        const dismissed = parseInt(localStorage.getItem(KEY), 10);
        if (dismissed && Date.now() - dismissed < DAYS * 864e5) return;
    } catch (e) {
        // Storage can be blocked; the panel still works without remembering
    }

    // Don't compete with a signup form that is already on screen
    function formInView() {
        return Array.from(document.querySelectorAll('.sc-inline-cta:not([hidden]) .sc-form, .sc-post-cta .sc-form')).some(function (form) {
            const rect = form.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        });
    }

    let shown = false;
    function onScroll() {
        const rect = content.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / rect.height;

        if (!shown && progress > 0.6 && !formInView()) {
            shown = true;
            panel.hidden = false;
            requestAnimationFrame(function () {
                panel.classList.add('is-visible');
            });
        }

        // Step aside when the end-of-post signup comes into view
        if (shown) {
            panel.classList.toggle('is-tucked', formInView());
        }
    }

    function dismiss() {
        panel.classList.remove('is-visible');
        window.removeEventListener('scroll', onScroll);
        setTimeout(function () {
            panel.hidden = true;
        }, 300);
        try {
            localStorage.setItem(KEY, String(Date.now()));
        } catch (e) {
            // Ignore blocked storage
        }
    }

    panel.querySelector('[data-sc-dismiss]').addEventListener('click', dismiss);
    window.addEventListener('scroll', onScroll, {passive: true});
})();

/* Glossary: A to Z jump bar and live search built from the page's H2 terms */
(function () {
    const tools = document.querySelector('[data-sc-glossary]');
    const content = document.querySelector('[data-sc-glossary-content]');
    if (!tools || !content) return;

    const headings = Array.from(content.querySelectorAll(':scope > h2'));
    if (headings.length < 5) return;

    // Group each term heading with the content that follows it
    const terms = headings.map(function (heading, i) {
        if (!heading.id) {
            heading.id = 'term-' + heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
        }
        const nodes = [heading];
        let next = heading.nextElementSibling;
        while (next && next.tagName !== 'H2') {
            nodes.push(next);
            next = next.nextElementSibling;
        }
        return {
            heading: heading,
            nodes: nodes,
            letter: heading.textContent.trim().charAt(0).toUpperCase(),
            text: nodes.map(function (n) {
                return n.textContent;
            }).join(' ').toLowerCase()
        };
    });

    // A to Z bar: letters with no term are shown but disabled
    const lettersNav = tools.querySelector('[data-sc-glossary-letters]');
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter) {
        const first = terms.find(function (t) {
            return t.letter === letter;
        });
        const el = document.createElement(first ? 'a' : 'span');
        el.textContent = letter;
        if (first) {
            el.href = '#' + first.heading.id;
        } else {
            el.setAttribute('aria-disabled', 'true');
        }
        lettersNav.appendChild(el);
    });

    const input = tools.querySelector('[data-sc-glossary-search]');
    const empty = tools.querySelector('[data-sc-glossary-empty]');

    function filter() {
        const query = input.value.trim().toLowerCase();
        let matches = 0;
        terms.forEach(function (term) {
            // Match on the term name first, then its definition
            const hit = !query || term.heading.textContent.toLowerCase().includes(query) || term.text.includes(query);
            term.nodes.forEach(function (n) {
                n.classList.toggle('sc-glossary-hidden', !hit);
            });
            if (hit) matches++;
        });
        empty.hidden = matches > 0;
        lettersNav.classList.toggle('is-filtering', !!query);
    }

    input.addEventListener('input', filter);
    tools.querySelector('[data-sc-glossary-clear]').addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        filter();
        input.focus();
    });

    tools.hidden = false;
})();

/* Homepage proof strip: split "a · b · c" into separate items */
(function () {
    const strip = document.querySelector('[data-sc-proof]');
    if (!strip) return;

    const items = strip.textContent.split('·').map(function (item) {
        return item.trim();
    }).filter(Boolean);
    if (items.length < 2) return;

    strip.textContent = '';
    items.forEach(function (item) {
        const span = document.createElement('span');
        span.textContent = item;
        strip.appendChild(span);
    });
})();
